export default {
  email: (v: any) =>
    /.+@.+\..+/.test(v) || "Debe ser un correo electrónico válido",
  password: (v: any) =>
    (v && v.length > 5) ||
    "La contraseña debe ser mayor o igual a 6 caracteres",
  notEmpty: (v: any) => (v && v.length > 0) || "El campo no puede ser vacio",
  positive: (v: any) => v >= 0 || "El campo no puede ser negativo",
  notZero: (v: any) => v > 0 || "El campo debe ser mayor a 0",
  notZeroCost: (v: any) =>
    v !== "$0.00" || "El campo no puede tener un costo de $0.00",
  files: (value: any) =>
    !value ||
    value.size < 5000000 ||
    "Fotos o archivos deben ser menores a 5 MB",
  notFiles: (value: any) => !!value || "Seleccione una foto",
  media: (value: any) =>
    !value ||
    value.size < 50000000 ||
    "Videos o fotos deben ser menores a 50 MB"
};
